import { render } from "./LeavePeriodDropdown.vue?vue&type=template&id=e53b94cc"
import script from "./LeavePeriodDropdown.vue?vue&type=script&lang=js"
export * from "./LeavePeriodDropdown.vue?vue&type=script&lang=js"

import exportComponent from "/Users/soil2sons/Projects/Work/Ensibuuko/hrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__